import './assets/styling/tailwind.css';
import 'vue-toastification/dist/index.css';
import './assets/styling/global-styling.css';

import vtkProxyManager from '@kitware/vtk.js/Proxy/Core/ProxyManager';
import vtkImageMapper from '@kitware/vtk.js/Rendering/Core/ImageMapper';
import vtkMapper from '@kitware/vtk.js/Rendering/Core/Mapper';
import { createPinia } from 'pinia';

import { createApp } from 'vue';

import { VueResponsiveness } from 'vue-responsiveness';
import VueToast from 'vue-toastification';

import App from './components/App.vue';
import { CorePiniaProviderPlugin } from './core/provider';
import ProxyWrapper from './core/proxies';

import vuetify from './plugins/vuetify';

import router from './router';

import { init as initErrorReporting } from './utils/errorReporting';
import { patchExitPointerLock } from './utils/hacks';
import proxyConfiguration from './vtk/proxy';

import '@kitware/vtk.js/Rendering/OpenGL/Profiles/Geometry';
import '@kitware/vtk.js/Rendering/OpenGL/Profiles/Volume';

import '@kitware/vtk.js/Rendering/OpenGL/Profiles/Glyph';

// patches
patchExitPointerLock();

// Initialize global mapper topologies
// polys and lines in the front
vtkMapper.setResolveCoincidentTopologyToPolygonOffset();
vtkMapper.setResolveCoincidentTopologyPolygonOffsetParameters(-3, -3);
vtkMapper.setResolveCoincidentTopologyLineOffsetParameters(-3, -3);
// image poly in the back
vtkImageMapper.setResolveCoincidentTopologyToPolygonOffset();
vtkImageMapper.setResolveCoincidentTopologyPolygonOffsetParameters(1, 1);

const proxyManager = vtkProxyManager.newInstance({ proxyConfiguration });

const pinia = createPinia();
pinia.use(
  CorePiniaProviderPlugin({
    proxies: new ProxyWrapper(proxyManager),
  }),
);

const app = createApp(App);

initErrorReporting(app);

app.provide('ProxyManager', proxyManager);
app.use(pinia);
app.use(VueToast);
app.use(vuetify);
app.use(VueResponsiveness, {
  smallLaptop: 1200,
  mediumLaptop: 1300,
  largerLaptop: 1400,
  xLargeLaptop: 1600,
  desktop: 1900,
  _4K: 2500,
});

// Disable Vue's logs & warnings in production

if (false) {
  app.config.warnHandler = () => {};
  app.config.errorHandler = () => {};
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

app.use(router).mount('#app');
